import { __assign, __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import Sidebar from '../_partials/Sidebar';
import UploadButton from '../_partials/UploadButton';
import UploadDropzone from '../_partials/UploadDropzone';
import FormPopup from '../../Popup/Form/';
import { MediaSourceType, MediaPopupMode } from '../types';
import { DEFAULT_MEDIASOURCE_TYPES } from '../constants';
import MediaSourceMenu from '../_partials/MediaSourceMenu';
import GallectionExplorer from '../Gallections/GallectionExplorer';
import GallectionDeviationSelector from '../Deviations/DeviationSelector/GallectionDeviationSelector';
import BrowseDeviationSelector from '../Deviations/DeviationSelector/BrowseDeviationSelector';
import MobileHeaderBackButton from '../_partials/BackButton/MobileHeaderBackButton';
import withOwnReduxStore from '../_hocs/withOwnReduxStore';
import withCurrentMediaSource from '../_hocs/withCurrentMediaSource';
import withCurrentGallection from '../_hocs/withCurrentGallection';
import withSelectedDeviations from '../_hocs/withSelectedDeviations';
import withMediaPopupInit from '../_hocs/withMediaPopupInit';
import withSearch from '../_hocs/withSearch';
import { withMobileContext } from '../../Context';
import s from '../MediaPopup.scss';
var enhance = compose(withOwnReduxStore, withCurrentMediaSource, withMediaPopupInit, withCurrentGallection, withSelectedDeviations, withSearch, withMobileContext, withTranslation());
var MediaSelector = /** @class */ (function (_super) {
    __extends(MediaSelector, _super);
    function MediaSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderDesktop = function () {
            var allowUploads = _this.props.allowUploads;
            return (React.createElement(FormPopup, __assign({}, _this.getFormPopupProps(), { withCancelBtn: false }),
                allowUploads && React.createElement(UploadDropzone, null),
                _this.renderSidebar(),
                _this.renderContentArea()));
        };
        _this.renderMobile = function () {
            return (React.createElement(FormPopup, __assign({}, _this.getFormPopupProps(), { headerExtras: React.createElement(MobileHeaderBackButton, null) }), _this.renderContentArea()));
        };
        _this.getFormPopupProps = function () {
            var _a = _this.props, className = _a.className, onClose = _a.onClose, selectedDeviations = _a.selectedDeviations, title = _a.title, submitBtnLabel = _a.submitBtnLabel, t = _a.t;
            return {
                isOpen: true,
                withContentPaddings: false,
                title: title || _this.getTitle(),
                className: classnames(s['root'], className),
                contentClassName: s['content'],
                headerClassName: s['header'],
                submitBtnLabel: submitBtnLabel || t('mediapopup.select'),
                onSubmit: _this.onSelect,
                disabledSubmit: !selectedDeviations.length,
                onClose: onClose,
            };
        };
        _this.onSelect = function () {
            _this.props.onSelect && _this.props.onSelect(_this.props.selectedDeviations);
        };
        return _this;
    }
    MediaSelector.prototype.componentDidMount = function () {
        var _a = this.props, initialMediaSource = _a.initialMediaSource, mediaSourceTypes = _a.mediaSourceTypes, withMediaSourceSelector = _a.withMediaSourceSelector, selectionLimit = _a.selectionLimit, initMediaPopup = _a.initMediaPopup, allowedDeviationTypes = _a.allowedDeviationTypes, allowGifs = _a.allowGifs, allowUploads = _a.allowUploads, minDeviationWidth = _a.minDeviationWidth, minDeviationHeight = _a.minDeviationHeight;
        initMediaPopup({
            mode: MediaPopupMode.SELECTOR,
            mediaSource: initialMediaSource,
            mediaSourceTypes: mediaSourceTypes,
            withMediaSourceSelector: withMediaSourceSelector,
            selectionLimit: selectionLimit,
            allowedDeviationTypes: allowedDeviationTypes,
            allowGifs: allowGifs,
            allowUploads: allowUploads,
            minDeviationWidth: minDeviationWidth,
            minDeviationHeight: minDeviationHeight,
        });
    };
    MediaSelector.prototype.render = function () {
        var isMobile = this.props.isMobile;
        return isMobile ? this.renderMobile() : this.renderDesktop();
    };
    MediaSelector.prototype.getTitle = function () {
        var _a = this.props, selectionLimit = _a.selectionLimit, t = _a.t;
        return selectionLimit && selectionLimit > 1
            ? t('mediapopup.selectDeviations')
            : t('mediapopup.selectDeviation');
    };
    MediaSelector.prototype.renderSidebar = function () {
        var _a = this.props, allowUploads = _a.allowUploads, withMediaSourceSelector = _a.withMediaSourceSelector;
        if (!withMediaSourceSelector) {
            return null;
        }
        return (React.createElement(Sidebar, null,
            allowUploads && React.createElement(UploadButton, { className: s['upload-btn'] }),
            React.createElement(MediaSourceMenu, { mediaSourceTypes: this.props.mediaSourceTypes })));
    };
    MediaSelector.prototype.renderContentArea = function () {
        var _a = this.props, currentMediaSource = _a.currentMediaSource, currentGallection = _a.currentGallection, searchQuery = _a.searchQuery;
        if (currentMediaSource === MediaSourceType.BROWSE) {
            return React.createElement(BrowseDeviationSelector, null);
        }
        else {
            if (!currentGallection && !searchQuery) {
                return React.createElement(GallectionExplorer, null);
            }
            return React.createElement(GallectionDeviationSelector, null);
        }
    };
    MediaSelector.defaultProps = {
        initialMediaSource: MediaSourceType.GALLERY,
        withMediaSourceSelector: true,
        mediaSourceTypes: DEFAULT_MEDIASOURCE_TYPES,
        selectionLimit: 1,
        allowUploads: true,
        allowGifs: true,
    };
    return MediaSelector;
}(React.Component));
export { MediaSelector };
export default enhance(MediaSelector);
//# sourceMappingURL=MediaSelector.connected.js.map